import React from 'react';
import { stripeFont } from '../../config';
import { PX } from '../../contrib/ui';
import { IStripeToken } from '../../store/user/store';

import Create from '@material-ui/icons/Create';

import {
  CardCVCElement,
  CardExpiryElement,
  CardNumberElement,
  injectStripe,
  PostalCodeElement
} from 'react-stripe-elements';

interface IProps {
  stripe?: any;
  ref?: React.RefObject<any>;
  onSubmit: (token: IStripeToken) => void;
  onCardUpdate: (e: stripe.elements.ElementChangeResponse) => void;
}

type FocusedType = 'name' | 'number' | 'expiration' | 'cvc' | 'code' | undefined;

interface IState {
  cardNumberError: string;
  cardError: string;
  name: string;
  focused: FocusedType;
}

export class DummyCheckoutForm extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      cardError: '',
      cardNumberError: '',
      focused: undefined,
      name: ''
    };
    this.handleCardName = this.handleCardName.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  public submit(): void {
    this.props.stripe
      .createToken({ name: this.state.name })
      .then(({ token }: { token: IStripeToken }) => {
        this.props.onSubmit(token);
      });
  }

  public handleCardName(event: { target: { value: string } }): void {
    const name = event.target.value;
    this.setState({ name });
    this.props.onCardUpdate({
      brand: '',
      complete: name.length > 3,
      elementType: 'cardName',
      empty: name.length > 0
    });
  }

  public handleChange(event: stripe.elements.ElementChangeResponse): void {
    if (event.error) {
      if (event.elementType === 'cardNumber') {
        this.setState({ cardNumberError: event.error.message || '' });
      } else {
        this.setState({ cardError: event.error.message || '' });
      }
    }
    if (this.state.cardNumberError && event.elementType === 'cardNumber' && !event.error) {
      this.setState({ cardNumberError: '' });
    } else if (this.state.cardError && !event.error) {
      this.setState({ cardError: '' });
    }
    this.props.onCardUpdate(event);
  }

  public onFocus = (focused: FocusedType) => () => {
    this.setState({ focused });
  };

  public onBlur = (focused: FocusedType) => () => {
    if (this.state.focused === focused) {
      this.setState({ focused: undefined });
    }
  };

  public render(): JSX.Element {
    const { focused } = this.state;
    return (
      <div id="card-form">
        <label>Name On Card</label>
        <div className={`input ${focused === 'name' ? 'focused' : ''}`}>
          <input
            className="name-input"
            value={this.state.name}
            onChange={this.handleCardName}
            onFocus={this.onFocus('name')}
            onBlur={this.onBlur('name')}
            type="text"
          />
          <Create color="primary" className="input-icon" />
        </div>
        <label>Credit Card Number</label>
        <div className={`input ${focused === 'number' ? 'focused' : ''}`}>
          <CardNumberElement
            onChange={this.handleChange}
            onFocus={this.onFocus('number')}
            onBlur={this.onBlur('number')}
            style={{
              base: {
                fontFamily: `${stripeFont.name}, sans-serif`,
                fontSize: `${16 * PX}px`,
                textAlign: 'center'
              }
            }}
          />
          <Create color="primary" className="input-icon" />
        </div>
        {this.state.cardNumberError && <div className="error">{this.state.cardNumberError}</div>}
        <div className="flex-row">
          <div className="flex-col">
            <label>Expiration</label>
            <div className={`input ${focused === 'expiration' ? 'focused' : ''}`}>
              <CardExpiryElement
                onChange={this.handleChange}
                onFocus={this.onFocus('expiration')}
                onBlur={this.onBlur('expiration')}
                style={{
                  base: {
                    fontFamily: `${stripeFont.name}, sans-serif`,
                    fontSize: `${16 * PX}px`,
                    textAlign: 'center'
                  }
                }}
              />
              <Create color="primary" className="input-icon" />
            </div>
          </div>
          <div className="flex-col cvv-col">
            <label>CVV #</label>
            <div className={`input ${focused === 'cvc' ? 'focused' : ''}`}>
              <CardCVCElement
                onChange={this.handleChange}
                onFocus={this.onFocus('cvc')}
                onBlur={this.onBlur('cvc')}
                style={{
                  base: {
                    fontFamily: `${stripeFont.name}, sans-serif`,
                    fontSize: `${16 * PX}px`,
                    textAlign: 'center'
                  }
                }}
              />
              <Create color="primary" className="input-icon" />
            </div>
          </div>
          <div className="flex-col">
            <label>Postal Code</label>
            <div className={`input ${focused === 'code' ? 'focused' : ''}`}>
              <PostalCodeElement
                onChange={this.handleChange}
                onFocus={this.onFocus('code')}
                onBlur={this.onBlur('code')}
                style={{
                  base: {
                    fontFamily: `${stripeFont.name}, sans-serif`,
                    fontSize: `${16 * PX}px`,
                    textAlign: 'center'
                  }
                }}
              />
              <Create color="primary" className="input-icon" />
            </div>
          </div>
        </div>
        <div className="flex-col">
          {this.state.cardError && (
            <div className="error general-error">{this.state.cardError}</div>
          )}
        </div>
      </div>
    );
  }
}

export default injectStripe(DummyCheckoutForm, { withRef: true });
